import React from 'react'; 
import Styles from './HyundaiCreta.module.css';
import Carousel from '../../../../components/Carousel/Carousel';
import { cars } from './Data';
import Hero from '../HeroForm/Hero';

const HyundaiCreta = () => {
  return (
    <div className={Styles.main_page}>
      <h2>Hyundai Creta</h2>

      {/* Carousel */}
      <div className={Styles.car_image}>
        <Carousel images={cars} />
      </div>

      {/* გადავცეთ მანქანის სახელი როგორც prop */}
      <Hero selectedCar="Hyundai Creta" />
    </div>
  );
}

export default HyundaiCreta;